// Hardcoded (non-AI) Tool selections streamed to the customizer in discovery mode.
//
// Mirrors discoveryAiTools.ts: selecting a Tool in the discovery panel streams a small marker that the
// customizer reads to enable that tool's sandbox experience. Get a Quote always runs a fully hardcoded
// sandbox in discovery mode — clicking the button opens a fixed 3-field form (Name, Last name, Email) and
// "submitting" just shows the success popup, with no backend call — see the customizer's useDiscoveryGetQuote.
//
// Add entries keyed by the DiscoveryModePanel item id.
export const DISCOVERY_TOOLS_PAYLOADS: Record<string, object> = {
    'get-a-quote': { tool: 'get-a-quote' }
    // AI Vectorizer + AI Background Remover payloads temporarily disabled (2026-07-06) alongside their pills
    // in DiscoveryModePanel (PREDEFINED_TOOLS). May be restored here or moved to another category — restore
    // both the pill and its payload together.
    //
    // AI Vectorizer reuses the customizer's real upload-time vectorize flow — see useDiscoveryAiVectorizer.
    // Unlike Get a Quote it has no hardcoded sandbox yet: it only runs for accounts that own VECTORIZE credits
    // (a credit-less mockup comes later).
    // 'ai-vectorizer': { tool: 'ai-vectorizer' },
    // AI Background Remover reuses the customizer's real upload-time BackgroundRemoverDialog — see
    // useDiscoveryAiBackgroundRemover. Background removal has NO account-credit signal (only per-product
    // config), so there's no hardcoded sandbox: selecting it opens the upload page and the real dialog fires
    // on products whose print type has background removal configured.
    // 'ai-background-remover': { tool: 'ai-background-remover' }
};
